import { useEffect, useState } from 'react';
import BraintreeClient from 'braintree-web/client';
import BraintreeApplePay from 'braintree-web/apple-pay';
import { useBraintreeClientToken } from '../../hooks/useBraintreeClientToken';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { reportError } from '../../lib/reportError';
import { useErrorModal } from '../../hooks/useErrorModal';

const createApplePayClient = async (token: string) => {
  const braintreeClient = await BraintreeClient.create({ authorization: token });
  const applePayClient = await BraintreeApplePay.create({ client: braintreeClient });
  return applePayClient;
};

type Props = {
  onError?: (error: unknown) => void;
};

export const useApplePayBraintreeClient = ({ onError }: Props = {}) => {
  const { showErrorModal } = useErrorModal();

  const { token, error: tokenError } = useBraintreeClientToken();

  const [applePayClient, setApplePayClient] = useState<BraintreeApplePay.ApplePay>();

  useEffect(() => {
    if (!token) return;
    createApplePayClient(token)
      .then(setApplePayClient)
      .catch(error => {
        reportError('APPLE_PAY_BRAINTREE_CLIENT_CREATE', error);
        showErrorModal();
        onError?.(error);
      });
  }, [token, showErrorModal, onError]);

  if (tokenError) throwQueryError(tokenError);

  return { client: applePayClient };
};
